import React from 'react';

import './blog-title.css'

const BlogTitle = ({title, date}) => {
    return (
        <header className = "blog-title">
            <div className="nub" />
            <div className="title-and-date">
                <h1>
                    {title}
                </h1>
                <h2>
                    {date}
                </h2>
            </div>
            <div className="nub inverted" />
        </header>
    );
}

export default BlogTitle;